module.exports = __webpack_public_path__ + "img/diao_guan_ji-icon2.94c967e6.png";